import { defineStore } from 'pinia';

// Shared between the plan, its overdue state and the payment modal while an instalment is being charged.
export const useInstallmentsChargingStore = defineStore('installmentsCharging', {
    state: () => ({
        isChargingInstallments: false,
    }),
    actions: {
        setActionStatus(status) {
            this.isChargingInstallments = status;
        },
    },
});
